import clsx from 'clsx'

import { Text } from '@wartek-id/text'

export const TooltipProvince = ({ tables, name }) => {
  const hasFooter = tables.find((i) => i.footer)
  const tablesBody = tables.filter((i) => !i.footer)
  const tablesFooter = tables.filter((i) => i.footer)

  return (
    <div className="min-w-[170px] max-w-[200px] p-2">
      <Text variant="heading-sm" color="inverse">
        {name}
      </Text>
      <table className="mt-4 w-full">
        <tbody>
          {tablesBody.map((row, index) => (
            <tr key={row.text}>
              <td
                className={clsx(
                  'py-1',
                  row.text === 'Total' ? 'font-bold' : '',
                  hasFooter && index === tablesBody.length - 1 ? 'pb-4' : ''
                )}
              >
                {row.text}
              </td>
              <td
                className={clsx(
                  'py-1 text-right',
                  row.text === 'Total' ? 'font-bold' : '',
                  hasFooter && index === tablesBody.length - 1 ? 'pb-4' : ''
                )}
              >
                {new Intl.NumberFormat('id-ID', {}).format(row.value)}
              </td>
            </tr>
          ))}
        </tbody>
        {hasFooter && tablesFooter.length > 0 && (
          <tfoot className="border-t">
            {tablesFooter.map((row, index) => (
              <tr key={row.text}>
                <td className={clsx('py-1', index === 0 && 'pt-4')}>
                  {row.text}
                </td>
                <td className={clsx('py-1 text-right', index === 0 && 'pt-4')}>
                  {new Intl.NumberFormat('id-ID', {}).format(row.value)}
                </td>
              </tr>
            ))}
          </tfoot>
        )}
      </table>
    </div>
  )
}
